"use client";

import Link from "next/link";

import WentWrongError from "@/components/shared/WentWrongError";
import ThemeLogo from "@/components/shared/ThemeLogo";
import { WEBSITE_NAME } from "@/data/constants";

type ErrorProps = {
  error: Error;
  reset: () => void;
};

export default function Error({ error, reset }: ErrorProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen py-10 text-center">
      <Link href={`/`} className="mb-10" aria-label="Go to the homepage">
        <ThemeLogo alt={WEBSITE_NAME} className="h-[35px] lg:h-[40px] w-auto object-contain" />
      </Link>
      <WentWrongError error={error} reset={reset} />
    </div>
  );
}
